import { Injectable } from '@angular/core';
import { FuseMockApiService } from '@fuse/lib/mock-api';
import { analytics as analyticsData } from 'app/mock-api/dashboards/analytics/data';
import { cloneDeep } from 'lodash-es';

@Injectable({ providedIn: 'root' })
export class AnalyticsMockApi {
    private _analytics: any = analyticsData;

    /**
     * Constructor
     */
    constructor(private _fuseMockApiService: FuseMockApiService) {
        // Register Mock API handlers
        this.registerHandlers();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Register Mock API handlers
     */
    registerHandlers(): void {
        // -----------------------------------------------------------------------------------------------------
        // @ Sales - GET
        // -----------------------------------------------------------------------------------------------------
        this._fuseMockApiService
            .onGet('api/dashboards/analytics')
            .reply(() => [200, cloneDeep(this._analytics)]);

        this._fuseMockApiService
            .onGet('api/dashboards/summary')
            .reply(({ request }) => {
                return [
                    200,
                    {
                        Deposits: 0,
                        DepositCount: 0,
                        Withdrawals: 0,
                        WithdrawalCount: 0,
                        PlayersLoggedIn: 0,
                        PlayersRegistered: 2,
                        Profit: 0,
                        PlayersBalance: 0,
                        PlayersBonusBalance: 0,
                        CorrectionsUp: 0,
                        CorrectionsDown: 0,
                        DepositClientCount: 0,
                        WithdrawalClientCount: 0,
                        TournamentCost: 0,
                        LoginCount: 0,
                    },
                ];
            });
    }
}
